import styled from 'styled-components'
import { Button } from '@navent-jobs/ui-kit/components/button'
import { Modal } from '@navent-jobs/ui-kit/components/modal'
import { Link } from '@navent-jobs/ui-kit/components/link'
import { Icon } from '@navent-jobs/ui-kit/components/icon'

/**
 * Modal
 */

export const ModalComponent = styled(Modal)``

/**
 * Modal Body
 */

export const ModalBodyComponent = styled.div``

export const ModalBodyContainer = styled.div`
  margin: 0px 0px 32px;
`

export const ParagraphSimple = styled.p`
  font-size: 18px;
  font-style: normal;
  font-weight: normal;
  line-height: 20px;
  ${({ mb32 }) => mb32 && `margin-bottom: 32px;`}
`

/**
 * Modal Footer
 */

export const ModalFooterComponent = styled.div`
  @media (min-width: ${({ theme }) => theme.screen.smMin}) {
    padding: 0px 24px;
  }
`

export const ButtonContent = styled.div`
  margin-top: 32px;
  display: flex;
  flex-direction: column;

  @media (min-width: ${({ theme }) => theme.screen.smMin}) {
    flex-direction: row;
    justify-content: space-evenly;
  }
`

export const CustomButton = styled(Button)`
  width: 100%;
  @media (min-width: ${({ theme }) => theme.screen.mdMin}) {
    max-width: 188px;
    ${({ order }) => order && `order: 1;`}
  }
`

export const CustomIcon = styled(Icon)`
  display: inline-block;
  vertical-align: -6px;
  margin-right: 10px;
`

export const CustomLink = styled(Link)`
  margin-top: 10px;
  width: 100%;

  @media (min-width: ${({ theme }) => theme.screen.mdMin}) {
    width: 188px;
    margin-top: 0px;
  }
`

export const AlertasErrorText = styled.p`
  margin-top: 10px;
  color: red;
  font-size: 15px;
`

export const DuplicatedAlertTitle = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  & img {
    padding-bottom: 30px;
  }
`

export const ModalCrearAlertaValidacionText = styled.div`
  text-align: center;
  font-size: 18px;
`

export const LoaderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 262px;
`
